{
  "action": {
    "save": "Save",
    "saveChanges": "Save Changes",
    "openSidebar": "Open sidebar",
    "closeSidebar": "Close sidebar",
    "cancel": "Cancel",
    "edit": "Edit",
    "submit": "Submit",
    "create": "Create",
    "delete": "Delete",
    "close": "Close",
    "settings": "Settings",
    "signOut": "Sign out",
    "signIn": "Sign in",
    "addSprint": "Add Sprint",
    "addStory": "Add Story",
    "addTask": "Add Task",
    "backToBacklogs": "Back to Backlogs",
    "comment": "Comment",
    "selectGroup": "Select Group",
    "addGroup": "Add Group",
    "addCategory": "Add Category",
    "addStatus": "Add Status",
    "viewKanban": "View Kanban",
    "editSprint": "Edit Sprint",
    "closeSprint": "Close Sprint",
    "openSprint": "Open Sprint",
    "upload": "Upload",
    "browse": "Browse",
    "actions": "Actions",
    "copyToClipboard": "Copy to Clipboard",
    "copiedToClipboard": "Copied to Clipboard",
    "cannotCopiedToClipboard": "Cannot copy to Clipboard"
  },
  "title": {
    "relatedTasks": "Related Tasks",
    "story": "Story",
    "newStory": "New Story",
    "newTask": "New Task",
    "masterBacklogs": "Master Backlogs",
    "productBacklogs": "Product Backlogs",
    "layout": "Layout",
    "default": "Default",
    "horizontal": "Horizontal",
    "task": "Task",
    "tag": "Tags",
    "unassigned": "Unassigned",
    "search": "Search by keyword",
    "is_public": "Public",
    "progress": "Progress (Done / Total)",
    "totalStoryPoints": "Total Story Points",
    "points": "points",
    "backlogs": "Backlogs",
    "kanban": "Kanban",
    "openingSprints": "Opening Sprints",
    "closedSprints": "Closed Sprints"
  },
  "ticket": {
    "title": "Title",
    "titlePlaceholder": "Enter a title",
    "createdBy": "Created by",
    "lastUpdatedBy": "Last updated by",
    "category": "Category",
    "assignee": "Assignee",
    "status": "Status",
    "point": "Point",
    "sprint": "Sprint",
    "sort_order": "Sort Order",
    "body": "Description",
    "updatedBy": "Updated by",
    "updatedAt": "Updated at"
  },
  "category": {
    "title": "Title",
    "sortOrder": "Sort Order",
    "sort_order": "Sort Order",
    "color": "Color"
  },
  "status": {
    "title": "Title",
    "sortOrder": "Sort Order",
    "sort_order": "Sort Order",
    "isDone": "Done?",
    "is_done": "Done?"
  },
  "settings": {
    "settings": "Settings",
    "userSettings": "User Settings",
    "generalSettings": "General Settings",
    "groupManagements": "Group Managements",
    "ticketCategories": "Ticket Categories",
    "ticketStatuses": "Ticket Statuses",
    "theme": {
      "default": "Default (shadcn)"
    },
    "general": {
      "title": "Project Title",
      "description": "Project Description",
      "isPublic": "Public Project?",
      "ticketPrefix": "Ticket Prefix",
      "projectImage": "Project Image",
      "currentImage": "Current Image"
    }
  },
  "message": {
    "noPeriodSpecified": "No period specified",
    "noSprintsYet": "No sprints yet.",
    "noStoriesInBacklog": "No stories in backlog.",
    "noStoriesInThisSprint": "No stories in this sprint.",
    "noClosedSprints": "No closed sprints yet.",
    "noStories": "No stories.",
    "failedToMoveStory": "Failed to move story.",
    "failedToCreateSprint": "Failed to create sprint.",
    "failedToUpdateSprint": "Failed to update sprint.",
    "failedToCloseSprint": "Failed to close sprint.",
    "failedToOpenSprint": "Failed to open sprint.",
    "failedToUpdateStory": "Failed to update story.",
    "failedToMoveTask": "Failed to move task.",
    "failedToUpdateProjectSettings": "Failed to update project settings.",
    "failedToUploadImage": "Failed to upload image.",
    "failedToDeleteImage": "Failed to delete image.",
    "noStatusesYet": "No statuses yet.",
    "failedToCreateStatus": "Failed to create status.",
    "failedToUpdateStatus": "Failed to update status.",
    "failedToDeleteStatus": "Failed to delete status.",
    "noCategoriesYet": "No categories yet.",
    "failedToCreateCategory": "Failed to create category.",
    "failedToUpdateCategory": "Failed to update category.",
    "failedToDeleteCategory": "Failed to delete category.",
    "noGroupsAddedYet": "No groups added yet.",
    "noGroupsFound": "No groups found.",
    "failedToAddGroup": "Failed to add group.",
    "failedToRemoveGroup": "Failed to remove group.",
    "failedToCreate": "Failed to create.",
    "failedToUpdate": "Failed to update.",
    "failedToDelete": "Failed to delete.",
    "failedToAddComment": "Failed to add comment.",
    "failedToDeleteComment": "Failed to delete comment.",
    "failedToUpdatePoint": "Failed to update point.",
    "areYouSure": "Are you sure?",
    "withStory": "With Story",
    "leaveAComment": "Leave a comment",
    "leaveADescription": "Enter a description (Markdown available)",
    "noDescription": "No description",
    "confirmDiscardChanges": "You have unsaved changes. Discard them?",
    "groups": "Groups",
    "chooseAFile": "Choose a file ...",
    "updateProjectSettingsSuccess": "Project Settings was successfully updated.",
    "closedSprintDoesNotExists": "Closed Sprint doesn't exists",
    "sprintDoesNotExists": "No sprints found. Use the \"Add Sprint\" button in the Product Backlog on the right to create one.",
    "storyDoesNotExists": "Story doesn't exists. Let's create a story with the \"Add Story\" button.",
    "storyDoesNotExistsInSprint": "Story doesn't exists. Let's add the added story to Sprint by D&D from Backlogs.",
    "dropHere": "Drop here",
    "historyIsEmpty": "History is empty.",
    "tagInput": "Please input tags",
    "publicProject": "This is a public project. Non-member users are only allowed to comment on tickets.",
    "addGroup": "Enter a few characters for the group name you want to add to the project. If you want to add a user, enter the username."
  },
  "sync": {
    "unavailable": "sync unavailable",
    "unavailableTooltip": "Real-time sync is unavailable. Please reload the page.",
    "reconnecting": "reconnecting...",
    "reconnectingTooltip": "Connection lost. Reconnecting...",
    "justNow": "just now",
    "secondsAgo": "{{count}} seconds ago",
    "minuteAgo": "1 minute ago",
    "minutesAgo": "{{count}} minutes ago",
    "hourAgo": "1 hour ago",
    "hoursAgo": "{{count}} hours ago"
  },
  "tab": {
    "comment": "Comment",
    "history": "History"
  }
}
